export function unique(arr) {
	const map = new Map();
	const newArr = arr.filter((v) => !map.has(v.text) && map.set(v.text, v));
	return newArr;
}
